import { Card } from '@uhg-abyss/web/ui/Card';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { lobAbbreviationToText } from '@repo/utils';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { capitalizeName } from '@repo/utils';

type MemberInformationProps = {
  memberId: string;
  name: string;
  dob: string;
  zipcode: string;
  lob: string;
  showAssessmentButton: boolean;
};

const InlineLabel = styled('span', {
  display: 'inline-block',
  fontWeight: 'bold',
});

export const MemberInformation = ({
  memberId,
  name,
  dob,
  zipcode,
  lob,
  showAssessmentButton,
}: MemberInformationProps) => {
  const formattedMemberName: string = capitalizeName(name);
  const lobText: string = lobAbbreviationToText(lob) ?? lob;

  return (
    <React.Fragment>
      <Card>
        <div style={{ border: '0px', paddingLeft: '0px', paddingRight: '0px' }}
        >
          <Flex alignContent="center" direction="column">
            {/* Member's name (heading) */}
            <Grid.Col>
              <Heading size = "sm">{formattedMemberName}</Heading>
            </Grid.Col>
            <Flex alignContent="center" direction="column">
              <Grid.Col style={{ paddingBottom: '0px' }}>
                <Text>
                  <InlineLabel>ID: </InlineLabel> {memberId}{' '}
                  <InlineLabel>DOB: </InlineLabel> {dob}{' '}
                  <InlineLabel>ZIP Code: </InlineLabel> {zipcode}
                </Text>
              </Grid.Col>
              <Grid.Col style={{ paddingTop: '0px' }}>
                <Text>
                  <InlineLabel>Line of Business: </InlineLabel> {lobText}
                </Text>
              </Grid.Col>
            </Flex>
            <Grid.Col>
              <Flex justify="space-between" style={{ gap: '8px', flexWrap: 'wrap' }}>
                <Button id="memberProfile" size="$md" href="/memberprofile">
                  Member Profile
                </Button>
                {showAssessmentButton && (
                  <Button size="$md" variant="outline" href="/question">
                    SDOH Screener
                  </Button>
                )}
              </Flex>
            </Grid.Col>
          </Flex>
        </div>
      </Card>
    </React.Fragment>
  );
};
